import { clear, get, put, STORE_INVENTORY, STORE_REFERENCE } from './db';

/**
 * Локальные данные принадлежат компании, в которую вошли.
 *
 * <p><b>Почему это не мелочь.</b> IndexedDB — хранилище браузера, а не
 * компании: войдя другой компанией на том же устройстве, кладовщик видел
 * лист обхода и справочники предыдущей — чужие наименования, чужие ячейки,
 * чужие машины. На складе с одним арендатором этого не заметить, а на прогоне
 * видно сразу.
 *
 * <p><b>Кэши стираются, очередь — нет.</b> Справочники и лист обхода
 * скачиваются заново одним запросом, а в очереди лежит несделанная работа
 * приёмщика: удалить её значит потерять смену. Записи чужой компании
 * не удаляются и не отправляются — их держит проверка в самой очереди,
 * потому что уехав в текущую сессию, они создали бы детали на чужом складе.
 */
const KEY_COMPANY = 'company';

/** Схема компании, которой принадлежат локальные данные. */
export async function localCompany(): Promise<string | null> {
  return (await get<string>(STORE_REFERENCE, KEY_COMPANY)) ?? null;
}

/**
 * Приводит локальные данные к вошедшей компании.
 *
 * @returns true, если данные принадлежали другой компании и были сброшены
 */
export async function scopeTo(companySchema: string): Promise<boolean> {
  const previous = await localCompany();
  if (previous === companySchema) {
    return false;
  }

  // Отметки нет — значит данные записаны до её появления и принадлежат
  // неизвестно кому. Оставить их «на всякий случай» значит показать чужой
  // лист обхода тому, кто обновил приложение: кэш восстановим одним
  // запросом, чужие наименования на экране — нет.
  await clear(STORE_REFERENCE);
  await clear(STORE_INVENTORY);
  await put(STORE_REFERENCE, companySchema, KEY_COMPANY);
  return true;
}
